import { MATCH_FLOWS, MATCH_FLOW_LOCAL_KEY } from './constants';

const getPossibleMatchFlows = () => Object.values(MATCH_FLOWS);

const setMatchFlow = (flow) => {
  if (getPossibleMatchFlows().includes(flow)) {
    localStorage.setItem(MATCH_FLOW_LOCAL_KEY, flow);
  }
};

const unsetMatchFlow = () => {
  localStorage.removeItem(MATCH_FLOW_LOCAL_KEY);
};

const getMatchFlow = () => localStorage.getItem(MATCH_FLOW_LOCAL_KEY);

export const MatchFlow = {
  setMatchFlow,
  getMatchFlow,
  unsetMatchFlow,
};
